<!--
 * @Description: 人员/证书审核详情组件
 * @Author: gaohc
 * @Date: 2022-11-09 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="dialog-attendant-review" width="1200px" title="审核详情"
      :visible.sync="visible" :close-on-click-modal="false"
      @open="initData" :before-close="handleCancel" center>
      <div class="details-wrap" :style="{'flex-direction': reviewType == 7 
        || reviewType == 11 ? 'column-reverse' : 'column'}">
        <attendant-review-baseinfo v-if="attendantDo.attendant" 
          :review="attendantDo.review" :isGlobalAdmin="isGlobalAdmin"
          @handle-attendant-review="handleReviewAttendant"
          :reviewHistoryList="attendantDo.attendanRreviewHistoryList"
          :baseInfo="attendantDo.attendant" :reviewType="reviewType" />
        <attendant-review-certinfo :reviewType="reviewType" 
          v-if="attendantDo.currentCertificate || attendantDo.certificateList" 
          :isGlobalAdmin="isGlobalAdmin"
          :otherCertificateList="attendantDo.otherCertificateList"
          :currentCertificate="attendantDo.currentCertificate" 
          :trainingCertCfgList="attendantDo.trainingCertCfgList"
          :certificateList="attendantDo.certificateList"
          @handle-cert-review="handleReviewCert" />
        <attendant-review-acceptinfo v-if="false" 
          :review="attendantDo.review" :isGlobalAdmin="isGlobalAdmin"
          @handle-attendant-review="handleReviewAttendant"
          :reviewHistoryList="attendantDo.attendanRreviewHistoryList"
          :baseInfo="attendantDo.attendant" :reviewType="reviewType" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import AttendantReviewBaseInfo from './attendantReviewDetails/AttendantReviewBaseInfo.vue'
import AttendantReviewCertInfo from './attendantReviewDetails/AttendantReviewCertInfo.vue'
import AttendantReviewAcceptInfo from './attendantReviewDetails/AttendantReviewAcceptInfo.vue'

export default {
  name: "AtdnOrCertReviewDetails",
  props: ["visible", "attendantId", "isGlobalAdmin", "reviewType"],

  components: {
    "attendant-review-baseinfo": AttendantReviewBaseInfo,
    "attendant-review-certinfo": AttendantReviewCertInfo,
    "attendant-review-acceptinfo": AttendantReviewAcceptInfo,
  },

  data() {
    return {
      attendantDo: {},
      compareCert: {}
    };
  },

  methods: {
    initData() {
      let url = this.reviewType == 7 || this.reviewType == 11 ?
        Constant.URL_GET_CERTIFICATE_REVIEW_DO : 
        Constant.URL_GET_ATTENTDANT_BASEINFO_REVIEW_DO;
      let params = {id: this.attendantId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };

      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.attendantDo = result.data;
        if (this.reviewType == 7 || this.reviewType == 11 
          && !this.attendantDo.currentCertificate.review.status) {
          let certObj = this.attendantDo.currentCertificate.certificate;
          this.compareCert = {
            permanent: certObj.permanent,
            startDate: certObj.startDate,
            endDate : certObj.endDate,
            trainingCertCfgId: certObj.certCfgId,
          };
        }
      });
    },

    //证书审核通过/驳回
    handleReviewCert(reviewStatus, reviewObj) {
      let params = {
        permanent: reviewObj.certificate.permanent,
        startDate: reviewObj.certificate.startDate,
        endDate : reviewObj.certificate.endDate,
        trainingCertCfgId: reviewObj.certificate.certCfgId,
        status: reviewStatus,
        version: reviewObj.review.version,
        id: this.attendantId
      }
      this.compareCert.status = reviewStatus;
      this.compareCert.version = reviewObj.review.version;
      this.compareCert.id = this.attendantId;
      if (reviewStatus == 'reject' && this.judgeParamIsChange(params)) {
        this.handleRejectOper(params);
        return
      }

      this.$emit("handle-review-cert", params);
    },

    handleRejectOper(params) {
      this.$confirm('审核驳回后，证书修改无效！是否继续驳回？', '提示', {
          confirmButtonText: '继 续',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          this.$emit("handle-review-cert", params);
        })
    },

    //人员审核通过/驳回
    handleReviewAttendant(reviewStatus, version) {
      this.$emit("handle-review-attendant", reviewStatus, version);
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    clearData() {
      this.attendantDo = {};
      this.compareCert = {};
    },

    judgeParamIsChange(params) {
      return JSON.stringify(params) != JSON.stringify(this.compareCert) ?
        true : false; 
    }
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.dialog-attendant-review /deep/ .el-dialog .el-dialog__header{
  text-align: center;
}

.dialog-attendant-review /deep/ .el-dialog__header .el-dialog__title{
  color: #5B5B5B;
}


.details-wrap{
  display: flex;
}

.details-wrap /deep/ .el-empty {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/AtdnOrCertReviewDetails.vue